// Shared so the dashboard list and the individual records phrase it the same
// way. Someone who has never signed in should read identically wherever you
// happen to be looking at them.

export function since(iso) {
  if (!iso) return "never";
  const d = new Date(iso);
  if (isNaN(d)) return String(iso);
  const days = Math.floor((Date.now() - d.getTime()) / 86400000);
  if (days <= 0) return "today";
  if (days === 1) return "yesterday";
  if (days < 30) return `${days} days ago`;
  return d.toLocaleDateString("en-IN",
    { day: "2-digit", month: "short", year: "numeric" });
}
